import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class IdentificationError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('IdentificationError', ...args);
    }
}
export default IdentificationError;
